module.exports = "/_next/static/images/Trend03Visual-ebc9aebd249ea8003835accead2bd2ad.png";